import {
  ODataHeader,
  ODataString,
  ODataInteger,
  ODataBoolean,
  ODataDate,
  ODataDecimal,
} from "pbas-vue-components";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

var SickDayAdjudicationSettingsHeaders = [
  new ODataHeader({
    type: new ODataString("Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    isIdentifier: true,
  }),
  new ODataHeader({
    type: new ODataString("PlanId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.plan",
    type: new ODataString("Plan/Number"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("MemberGroupId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.effective_date",
    type: new ODataDate("EffectiveDate"),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("SickDayLimitUnit"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    sortable: false,
  }),
  new ODataHeader({
    title: "headers.sick_payment_settings.limits",
    type: new ODataDecimal("Limits[]/AmountPerSickDay", {
      getHtml: (item, type) => {
        let a = "";
        for (let o of item.Limits) {
          a+="<span>";
          a+=`up to ${o.UpperBoundary?o.UpperBoundary:'\u221e'.toString()} $${item.SickDayLimitUnit=='HourlyWage'?'per hour':'years'}: ${o.AmountPerSickDay}$ per sick day`;
          a+="</span><br>";
        }
        return a;
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    sortable: true,
  }),
  new ODataHeader({
    type: new ODataDecimal("Limits[]/UpperBoundary"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    sortable: false,
  }),
];

export default SickDayAdjudicationSettingsHeaders;
